import { API, graphqlOperation } from "aws-amplify";
import uuid from "uuid";

import * as mutations from '../../graphql/mutations';

import {
    UPDATE_CURRENT_APPLICATION_STATE
} from "../constants/action-types";

export async function saveSalaryAppSync(items, grantApplication, user, funcs) {

    items.forEach((payload) => {
        if (!payload.id) {
            // This means that you are creating a new salary
            let salaryFilter = {
                input: {
                    grantApplicationSalaryId: grantApplication.id,
                    name: payload.name,
                    positionTitle: payload.positionTitle,
                    federal: payload.federal || null,
                    county: payload.county || null,
                    countyInKind: payload.countyInKind || null,
                    deleted: payload.deleted,
                    updatedBy: user.username,

                    fbFederalFunding: payload.fbFederalFunding || null,
                    fbCountyCashFunding: payload.fbCountyCashFunding || null,
                    fbCountyInkindFunding: payload.fbCountyInkindFunding || null,                    
                }
            }

            funcs.push(API.graphql(graphqlOperation(mutations.createSalary, salaryFilter)));
        } else {

            // Check if this payload is different than the what is already saved

            let same = false;
            for (let index = 0; index < grantApplication.salary.items.length; index++) {
                const item = grantApplication.salary.items[index];
                if((item.id == payload.id) && (JSON.stringify(item) == JSON.stringify(payload))) {
                    same  = true;
                    break;
                }
            }

            if(!same) {
                let salaryFilter = {
                    input: {
                        grantApplicationSalaryId: grantApplication.id,
                        id: payload.id,
                        name: payload.name,
                        positionTitle: payload.positionTitle,
                        federal: payload.federal || null,
                        county: payload.county || null,
                        countyInKind: payload.countyInKind || null,
                        deleted: payload.deleted,
                        updatedBy: user.username,

                        fbFederalFunding: payload.fbFederalFunding || null,
                        fbCountyCashFunding: payload.fbCountyCashFunding || null,
                        fbCountyInkindFunding: payload.fbCountyInkindFunding || null,                        
                    }
                }
    
                funcs.push(API.graphql(graphqlOperation(mutations.updateSalary, salaryFilter)));
            } 
        } 
    })
}

export function saveSalary(payload) {
    return async function (dispatch, getState) {

        const { grantApplication, currentApplicationState } = getState().rootReducer;
        if (!currentApplicationState.salary.items) {
            currentApplicationState.salary.items = [];
        }

        if (!payload.id && !payload.tempId) {
            payload.tempId = uuid.v4();
        }

        let arr = currentApplicationState.salary.items, found = false;
        for (let i = 0; i < arr.length; i++) {
            let item = arr[i];
            if (item.tempId) {
                if (item.tempId == payload.tempId) {
                    currentApplicationState.salary.items[i] = payload;
                    found = true;
                    break;
                }
            } else {
                if (item.id == payload.id) {
                    currentApplicationState.salary.items[i] = payload;
                    found = true;
                    break;
                }
            }

        }

        if (!found) {
            currentApplicationState.salary.items.push(payload)
        }

        dispatch({ type: UPDATE_CURRENT_APPLICATION_STATE, payload: JSON.parse(JSON.stringify(currentApplicationState)) });

    }
}
